import {
  IconCalendar,
  IconCalendarFilled,
  IconHome,
  IconHomeFilled,
  IconMessage,
  IconMessageFilled,
  IconSchool,
  IconSearch,
  IconUser,
  IconUserFilled,
  IconUsers,
} from "@tabler/icons-react";
import { Route, Switch } from "wouter";
import { FindTraining } from "@/pages/owner/FindTraining";
import { GroupDetail, Groups, PublicGroupDetail } from "@/pages/owner/Groups";
import { DogPortraitUpload, PortraitUpload } from "@/pages/owner/Portait";
import { DogsProfile } from "@/pages/owner/profile/DogsProfile";
import { NewProfile } from "@/pages/owner/profile/NewProfile";
import { RequestSession } from "@/pages/owner/RequestSession";
import { Session } from "@/pages/owner/Session";
import { SessionList } from "@/pages/owner/SessonList";
import { SurveyPage } from "@/pages/owner/SurveyPage";
import { TrainerEngagement } from "@/pages/owner/TrainerEngagement";
import { TrainerInvite } from "@/pages/owner/TrainerInvite";
import { TrainersFinder } from "@/pages/owner/TrainersFinder";
import { Chat } from "@/pages/universal/Chat";
import { ChatsWithTabs } from "@/pages/universal/ChatsWithTabs";
import { FilePreview } from "@/pages/universal/FilePreview";
import { GroupChat } from "@/pages/universal/GroupChat";
import { NotFound } from "@/pages/universal/NotFound";
import { NotificationSettings } from "@/pages/universal/NotificationSettings";
import { Notifications } from "@/pages/universal/Notifications";
import { TrainerPage } from "@/pages/universal/TrainerPage";
import { type NavItem, OwnerRoutes, UniversalRoutes } from "@/routers/routes";
import { Home } from "../pages/owner/Home";
import { AccountSettings, OwnerProfile } from "../pages/owner/profile/Profile";

export const OwnerNavigationIcons = [
  {
    icon: IconHome,
    selectedIcon: IconHomeFilled,
    label: "Home",
    route: UniversalRoutes.HOME,
  },
  {
    icon: IconMessage,
    selectedIcon: IconMessageFilled,
    label: "Messages",
    route: [UniversalRoutes.CHAT.LIST, UniversalRoutes.GROUP_CHAT.DETAIL.base],
    chat: true as const,
  },
  {
    icon: IconSearch,
    label: "Trainings",
    route: OwnerRoutes.FIND_TRAINING,
  },
  {
    icon: IconUser,
    selectedIcon: IconUserFilled,
    label: "Profile",
    route: UniversalRoutes.PROFILE.HOME,
  },
] as const satisfies NavItem[];

export const OwnerNavigationIconsDesktop = [
  {
    icon: IconHome,
    selectedIcon: IconHomeFilled,
    label: "Home",
    route: UniversalRoutes.HOME,
  },
  {
    icon: IconMessage,
    selectedIcon: IconMessageFilled,
    label: "Messages",
    route: [UniversalRoutes.CHAT.LIST, UniversalRoutes.GROUP_CHAT.DETAIL.base],
    chat: true as const,
  },
  {
    icon: IconSchool,
    label: "Find training",
    route: OwnerRoutes.FIND_TRAINING,
  },
  {
    icon: IconSearch,
    label: "Trainers",
    route: OwnerRoutes.LIST_TRAINERS,
  },
  {
    icon: IconCalendar,
    selectedIcon: IconCalendarFilled,
    label: "My Sessions",
    route: UniversalRoutes.SESSIONS.LIST,
  },
  {
    icon: IconUsers,
    selectedIcon: IconUsers,
    label: "My groups",
    route: UniversalRoutes.GROUPS.LIST,
  },
] as const satisfies NavItem[];

export function OwnerRouter() {
  return (
    <Switch>
      <Route path={UniversalRoutes.HOME}>
        <Home />
      </Route>
      <Route path={UniversalRoutes.PROFILE.CREATE}>
        <NewProfile />
      </Route>
      <Route path={UniversalRoutes.PROFILE.HOME}>
        <AccountSettings />
      </Route>
      <Route path={OwnerRoutes.PROFILE.DOGS}>
        <DogsProfile />
      </Route>
      <Route path={UniversalRoutes.PROFILE.PERSONAL_INFO}>
        <OwnerProfile />
      </Route>
      <Route path={UniversalRoutes.PROFILE.PORTRAIT}>
        <PortraitUpload />
      </Route>
      <Route path={OwnerRoutes.PROFILE.DOGS_PORTRAIT}>
        <DogPortraitUpload />
      </Route>
      <Route path={UniversalRoutes.PROFILE.NOTIFICATIONS}>
        <NotificationSettings />
      </Route>
      <Route path={OwnerRoutes.LIST_TRAINERS}>
        <TrainersFinder />
      </Route>
      <Route path={OwnerRoutes.FIND_TRAINING}>
        <FindTraining />
      </Route>
      {/* it is important to keep it above trainer details because it has optional which will eat the rest of the path */}
      <Route
        path={OwnerRoutes.REQUEST_SESSION.path}
        component={RequestSession}
      />
      <Route path={OwnerRoutes.TRAINERS.INVITE.path}>
        <TrainerInvite />
      </Route>
      <Route path={UniversalRoutes.TRAINERS.DETAIL.path}>
        <TrainerPage />
      </Route>
      <Route
        path={OwnerRoutes.TRAINER_ENGAGEMENT.path}
        component={TrainerEngagement}
      />
      <Route path={UniversalRoutes.SESSIONS.DETAIL.path} component={Session} />
      <Route path={UniversalRoutes.SESSIONS.LIST}>
        <SessionList />
      </Route>
      <Route path={UniversalRoutes.CHAT.LIST}>
        <ChatsWithTabs whoAmI="owner" />
      </Route>
      <Route path={UniversalRoutes.CHAT.DETAIL.path}>
        <Chat who="owner" />
      </Route>
      <Route path={UniversalRoutes.GROUP_CHAT.DETAIL.path}>
        <GroupChat />
      </Route>
      <Route path={UniversalRoutes.NOTIFICATIONS.LIST}>
        <Notifications />
      </Route>
      <Route path={OwnerRoutes.SURVEYS.FILL.path}>
        <SurveyPage />
      </Route>
      <Route path={UniversalRoutes.GROUPS.LIST}>
        <Groups />
      </Route>
      <Route path={UniversalRoutes.GROUPS.DETAIL.path}>
        <GroupDetail />
      </Route>
      <Route path={UniversalRoutes.GROUPS.JOIN.path}>
        <PublicGroupDetail />
      </Route>
      <Route path={UniversalRoutes.FILE_PREVIEW.path}>
        <FilePreview />
      </Route>
      <Route path={UniversalRoutes.TRAINER.path}>
        <TrainerPage />
      </Route>
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}
